module.exports = __webpack_public_path__ + "img/wallet_pc_03.7b6ba49b.png";